import React from 'react';
import { Link } from 'fw/components/formatter/Formatter';

class SearchQueueLinkByTypeAndRange extends React.Component {
	handleClick = (e) => {
		e.stopPropagation();
		return false;
	}

	shouldComponentUpdate(nextProps) {
		return nextProps.value !== this.props.value;
	}

	_getLinkValue() {
		const row = this.props.dependentValues[0];
		const rangeCode = this.props.dependentValues[1];
		const isTotalsRow = row.typeCode === 'TOTALS';

		let url = '/admin/searchQueue?showAll=true&certificationStatusCode=APL';

		// Add certification type filter only for non-TOTALS rows
		if (!isTotalsRow) {
			url += `&certificationTypeCode=${row.typeCode}`;
		}

		// Add days filter if specified
		if (rangeCode !== null) {
			url += `&certificationDaysOpen=${rangeCode}`;
		}

		return {
			url: url,
			title: this.props.value ? this.props.value : 0
		};
	}

	render() {
		const centerAlignStyle = { display: "block", textAlign: "center" };
		const value = this.props.value ? this.props.value : 0;

		// Zero value - show plain number without link
		if (value === 0) {
			return (
				<span style={centerAlignStyle}>
					{value}
				</span>
			);
		}

		return <Link value={this._getLinkValue()} style={centerAlignStyle}></Link>
	}
}

export default SearchQueueLinkByTypeAndRange;



// WEBPACK FOOTER //
// ./src/areas/shared/components/formatter/SearchQueueLinkByTypeAndRange.js